import React, { useEffect } from 'react';
import useCapabilities from './hooks/useCapabilities.js';
import useApiBase from './hooks/useApiBase.js';
import { setApiBase } from './api.js';
import useOnlineStatus from './hooks/useOnlineStatus.js';
import LoadingSpinner from './components/LoadingSpinner.jsx';
import FailoverBanner from './components/FailoverBanner.jsx';
import OfflineIndicator from './components/OfflineIndicator.jsx';

const FleetMapLayout = React.lazy(() => import('./fleet-map/components/FleetMapLayout.jsx'));

export default function App() {
  const failover = useApiBase();
  const { capabilities, loading: capLoading, error: capError } = useCapabilities();
  const online = useOnlineStatus();

  // Sync API base URL when failover switches to/from a peer
  useEffect(() => {
    setApiBase(failover.apiBase);
  }, [failover.apiBase]);

  if (capLoading && !capabilities) {
    return (
      <div className="app-loading">
        {!online && <OfflineIndicator />}
        <LoadingSpinner message="Connecting..." />
      </div>
    );
  }

  if (capError && !capabilities) {
    return (
      <div className="app-loading">
        {!online && <OfflineIndicator />}
        <FailoverBanner activePeer={null} />
        <div className="error-message">
          Failed to load capabilities: {capError}
        </div>
      </div>
    );
  }

  return (
    <React.Suspense fallback={<LoadingSpinner message="Loading fleet map..." />}>
      <FleetMapLayout capabilities={capabilities} online={online} failover={failover} />
    </React.Suspense>
  );
}
